<script setup lang="ts">
// eslint-disable-next-line vue/no-unused-properties
const props = defineProps<{ position: 'start' | 'end' }>()

</script>

<template>
  <div class="w-full"
       :class="props.position === 'start' ? 'md:pt-1.5 pt-1 md:pb-6 pb-4' : 'md:pt-1.5 pt-1 md:pb-8 pb-6'">
    <div class="relative flex items-center w-full gap-3">
      <div class="border-t border-gray-300 flex-grow pb-6 md:pb-0" />
      <slot name="badge" />
    </div>
  </div>
</template>
